<form *ngIf="validation && show.form" [formGroup]="addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" (ngSubmit)="saveOrUpdate(dialogBoxCountry)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.iso_code.nullable}">{{ validation.iso_code.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="iso_code" id="isoCode" name="isoCode" pInputText type="text" />
        <span class="input-error-notification" *ngIf="invalidSubmit && addEditForm.controls.iso_code.errors?.pattern">Inserire un codice ISO valido</span>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [arrayValidators]="[validators.patternIso]" [validation]="validation.iso_code"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.name.nullable}">{{ validation.name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="name" id="name" name="name" type="text" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.name"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.language_id.nullable}">{{ validation.language_id.keyName }}</label></div>
      <div class="ui-grid-col-8" >
        <p-autoComplete
        id="languages"
        name="languages"
        [suggestions]="languages"
        [(ngModel)]="model.language"
        [ngModelOptions]="{standalone: true}"
        (completeMethod)="filterLanguageSingle($event)"
        (onSelect)="onSelectLanguage($event)"
        placeholder="{{ 'common.language' | translate }}"
        (onClear)="onClearLanguage()"
        [minLength]="2"
        [required]="!validation.language_id.nullable"
        [dropdown]="true"
        field="language"
        >
        </p-autoComplete>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.language_id"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-100-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.currency_id.nullable}">{{ validation.currency_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-autoComplete
        id="currencies"
        name="currencies"
        [suggestions]="currencies"
        [(ngModel)]="model.currency"
        [ngModelOptions]="{standalone: true}"
        (completeMethod)="filterCurrencySingle($event)"
        (onSelect)="onSelectCurrency($event)"
        placeholder="{{ 'common.currency' | translate }}"
        (onClear)="onClearCurrency()"
        [minLength]="2"
        [required]="!validation.currency_id.nullable"
        [dropdown]="true"
        field="name"
        >
      </p-autoComplete>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.currency_id"></app-validation-msg>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <button id="save" name="save" class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="{{ 'common.save' | translate }}"></button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/country/countryForm.html